var simple_chart = function()
{
	var instance = {};

	//Set scope variable to init dbtable with options, columns etc
	instance.init = function(scope, componentKey, component)
	{
		//initalise component properties
		scope[componentKey] = {};
		scope[componentKey].instance = {};
		scope[componentKey].table_data = {};
		scope[componentKey].data = component.init_config;
		scope[componentKey].component = component;
	};
	instance.update = function(scope, componentKey, resultComponentVal)
	{
		var config_data = scope[componentKey].data;
		var component_config = scope[componentKey].component;

		//extend the component config with the result data
		$.extend( true, config_data, resultComponentVal.config );
		resultComponentVal.config = config_data;

		//reset component properties
		scope[componentKey] = {};
		scope[componentKey].instance = {};
		if(typeof(resultComponentVal.table_data) != 'undefined')
		{
			scope[componentKey].table_data = resultComponentVal.table_data;
		}

		var tootltipObj = {
			"enabled" : true,
			"useHTML":true,
			"borderColor": "#000",
			"backgroundColor": "#13161C",
			"style": {"color": "#fff","opacity":".8", "zIndex":"9999" },
			//"zIndex":9999,
			//"shadow": false,
			"borderWidth": 0,
			"animation": true,
			"borderRadius": "4",
			"formatter": function()
			{
				var y = this.point.y;
				var item_label = this.point.name;

				if(typeof resultComponentVal.config.tooltip_format != 'undefined')
				{
					var tooltip_string = typeof resultComponentVal.config.tooltip_format != 'undefined'?resultComponentVal.config.tooltip_format:'';
					var value = this.point.value;
					var count = this.point.count;
					var selected_sample_count = typeof this.point.selected_sample_count != 'undefined'?this.point.selected_sample_count:'';
					item_label = typeof this.series.name != 'undefined'?this.series.name:item_label;

					if(typeof this.point.target != 'undefined')
					{
						return "<span class='tooltip_container'>"+this.point.name+": "+y+"</span>";;
					}

					var result_string = tooltip_string.replace("{label}", item_label);
					var result_string = result_string.replace("{value}", value);
					var result_string = result_string.replace("{count}", count);
					var result_string = result_string.replace("{selected_sample_count}", selected_sample_count);
					return '<span class="tooltip_container"><span style="color:'+ this.series.color +'">\u25CF</span>'+result_string+"</span>";
				}
				if(typeof this.point.name != 'undefined')
				{
					var percentage = this.point.value;
					item_label = typeof this.point.tool_tip_name != 'undefined'?this.point.tool_tip_name:item_label;
					return '<span class="tooltip_container"><span style="color:'+ this.series.color +'">\u25CF</span>'+item_label+" : "+percentage+"</span>";
				}

			},
		}
		var positioner = function (labelWidth, labelHeight, point) {
				var height = this.chart.chartHeight-point.plotY+labelHeight+22 > this.chart.chartHeight? (point.plotY+22) : (point.plotY-labelHeight-8);
				var width = (this.chart.chartWidth / 2) - (labelWidth / 2);
				return {
					x: width,
					y: height
				};
			};

		var dataLabelsObj = {
			"crop": false,
			"enabled":true,
			"overflow": "none",
			"color": "#000000",
			"useHTML": true,
			"formatter": function(){
				if(typeof this.point.previous != 'undefined')
				{
					var previous_data = typeof this.point.previous != 'undefined'?this.point.previous:null;
					var arrow_up_color = typeof this.point.arrow_up_color != 'undefined'?this.point.arrow_up_color : 'green';
					var arrow_down_color = typeof this.point.arrow_down_color != 'undefined'?this.point.arrow_down_color : 'red';
					var null_data_display = this.point.null_data_display;
					var css_class = (this.y < 0) ? "datalabel datalabel-negative" : "datalabel";
					if(previous_data !== null)
					{
						if(isNaN(null_data_display) || null_data_display == null) {
							return '<span class="datalabel">'+null_data_display+'</span>';
						}
						
						return this.y > this.point.previous?'<span class="'+css_class+'">'+this.y+' <i style="color:'+arrow_up_color+'" class="fa fa-caret-up fa-lg"></i></span>':(this.y<this.point.previous?'<span class="'+css_class+'">'+this.y+' <i style="color:'+arrow_down_color+'" class="fa fa-caret-down fa-lg" /></span>':'<span class="datalabel">'+this.y+'</span>');
					}
					else
					{
						return '<span class="'+css_class+'">'+null_data_display+'</span>';
					}

				}
				else if(typeof this.point.y != 'undefined' && this.point.y < 0)
				{
					var css_class = "datalabel datalabel-negative";
					return '<span class="'+css_class+'">'+this.point.y+'</span>';
				}

				return Highcharts.numberFormat(this.y,1);
			}
		};

		if(typeof resultComponentVal.config != 'undefined' && 
			resultComponentVal.config != null &&
			typeof resultComponentVal.config.options != 'undefined' && 
			typeof resultComponentVal.config.options.tooltip != 'undefined' && 
			typeof resultComponentVal.config.options.tooltip.formatter != 'undefined')
		{
			resultComponentVal.config.options.tooltip = tootltipObj;
			if( typeof resultComponentVal.config.options.tooltip.positioner != 'undefined')
			{
				if(resultComponentVal.config.options.tooltip.positioner != false){
					resultComponentVal.config.options.tooltip.positioner = positioner;
				}
			}
		}


		if( typeof resultComponentVal.config != 'undefined' && 
			resultComponentVal.config != null &&
			typeof resultComponentVal.config.options != 'undefined' && 
			typeof resultComponentVal.config.options.plotOptions != 'undefined' && 
			typeof resultComponentVal.config.options.plotOptions.column != 'undefined' && 
			typeof resultComponentVal.config.options.plotOptions.column.dataLabels != 'undefined' &&
			typeof resultComponentVal.config.options.plotOptions.column.dataLabels.enabled != 'undefined' &&
			resultComponentVal.config.options.plotOptions.column.dataLabels.enabled != false )
		{
			resultComponentVal.config.options.plotOptions.column.dataLabels = dataLabelsObj;
		}

		if( typeof resultComponentVal.config != 'undefined' && 
			resultComponentVal.config != null &&
			typeof resultComponentVal.config.options != 'undefined' && 
			typeof resultComponentVal.config.options.plotOptions != 'undefined' && 
			typeof resultComponentVal.config.options.plotOptions.bar != 'undefined' && 
			typeof resultComponentVal.config.options.plotOptions.bar.dataLabels != 'undefined' &&
			typeof resultComponentVal.config.options.plotOptions.bar.dataLabels.enabled != 'undefined' &&
			resultComponentVal.config.options.plotOptions.bar.dataLabels.enabled != false )
		{
			// resultComponentVal.config.options.plotOptions.bar.dataLabels = dataLabelsObj;
		}

		//update stackLabels formatter (used only for stacked column charts with stackLabels enabled = true)
		if( typeof resultComponentVal.config != 'undefined' && 
			resultComponentVal.config != null &&
			typeof resultComponentVal.config.options != 'undefined' && 
			typeof resultComponentVal.config.options.yAxis != 'undefined' &&
			typeof resultComponentVal.config.options.yAxis.stackLabels!= 'undefined' &&
			typeof resultComponentVal.config.options.yAxis.stackLabels.enabled!= 'undefined' &&
			resultComponentVal.config.options.yAxis.stackLabels.enabled != false )
		{
			var stackedLabelsObject = {
				"style": {
					"color": "black"
				},
				"useHTML":true,
				"enabled": true,
				"formatter": function() {
					var series = this.axis.chart.series;
					var labelPoint = null;
					var compare_null_values = false;

					//Find the item in series array having the property show_value_as_label
					for (var i in series)
					{
						if (typeof series[i].options != 'undefined' && typeof series[i].options.show_value_as_label != 'undefined' && series[i].options.show_value_as_label == true)
						{
							labelPoint = series[i].options.data[this.x];
							compare_null_values = typeof series[i].options.compare_null_values != 'undefined'? series[i].options.compare_null_values: false;
							if (typeof series[i].options != 'undefined' && typeof series[i].options.metric_display_format != 'undefined')
                            {
							    labelPoint["metric_display_format"] = series[i].options.metric_display_format;
                            }	
							break;
						}
					}

					//If labelPoint not found
					if(labelPoint == null)
					{
						//Find the last series of the chart
						var series_length = series.length;
						series_length--;

						var labelPoint = ( typeof series[series_length] != 'undefined' &&
						typeof series[series_length].options.data != 'undefined' &&
						typeof series[series_length].options.data[this.x] != 'undefined' )? series[series_length].options.data[this.x]:{};
					}


					//If label point was found
					if(typeof labelPoint.y != 'undefined' && typeof labelPoint.previous != 'undefined')
					{
						var previous_data = typeof labelPoint.previous != 'undefined' ? labelPoint.previous : null;
						var arrow_up_color = typeof labelPoint.arrow_up_color != 'undefined'?labelPoint.arrow_up_color : 'green';
						var arrow_down_color = typeof labelPoint.arrow_down_color != 'undefined'?labelPoint.arrow_down_color : 'red';
						var null_data_display = labelPoint.null_data_display;
						var css_class = (labelPoint.y < 0) ? "datalabel datalabel-negative" : "datalabel";
						previous_data = compare_null_values == true && previous_data == null ? 0 :previous_data;
						if(previous_data !== null)
						{
							if(isNaN(null_data_display) || null_data_display == null) {
								return '<span class="datalabel">'+null_data_display+'</span>';
							}

							return labelPoint.y > labelPoint.previous?'<span class="'+css_class+'">'+labelPoint.y+' <i style="color:'+arrow_up_color+'" class="fa fa-caret-up fa-lg"></i></span>':(labelPoint.y<labelPoint.previous?'<span class="'+css_class+'">'+labelPoint.y+' <i style="color:'+arrow_down_color+'" class="fa fa-caret-down fa-lg" /></span>':'<span class="datalabel">'+labelPoint.y+'</span>');
						}
						else
						{
							//implemented in solidworks project
                            var all_metric_data = null_data_display;
                            if (typeof labelPoint.metric_display_format != 'undefined' && all_metric_data > 0)
                            {
                                all_metric_data = labelPoint.metric_display_format.replace("{y}",Highcharts.numberFormat(null_data_display,1).toString());
                            }
							return '<span class="'+css_class+'">'+all_metric_data+'</span>';
						}
					}

					return typeof labelPoint.y != 'undefined'?Highcharts.numberFormat(labelPoint.y,1):'-';
				}
			};
			resultComponentVal.config.options.yAxis.stackLabels = stackedLabelsObject;
		}

		if(typeof config_data.options.legendItemClick != 'undefined' &&
			config_data.options.legendItemClick == false) {
			//Disable legend item click action
			resultComponentVal.config.options.plotOptions.series.events = {
				legendItemClick: function () {return false;}
			};
		}

		//Basically this feature is applied for Audi 2021 updates like home page insights barchart. when we click each bar it need to redirect to comments page appying some filters in comments page.
		if(typeof config_data.options.plotOptions.series != 'undefined' && typeof component_config.config.redirect_on_click != 'undefined') {
			resultComponentVal.config.options.plotOptions.series = {
				cursor: 'pointer',
				stacking: 'normal',
				point: {
					events: {
						click: function () {

							// var output_series_value = component_config.config.output_series_items[this.category].value;
							var redirect_config = component_config.config.redirect_on_click;
							if(redirect_config){
								var all_filters = '';
								$.each(redirect_config.fixed_filters, function(key, value)
								{
									all_filters +=  key + '=' + value + '&';
								});

								all_filters = all_filters + redirect_config.output_filter.name + '=' + redirect_config.output_filter.refer_array[this.category];

								var getUrl = window.location.origin+'/Report/#/'+ redirect_config.page +'?submenu_key='+component_config.submenu_key+'&'+all_filters;

								var new_tab = (typeof(redirect_config.new_tab) != 'undefined') ? redirect_config.new_tab : false;

								if(new_tab === true)
								{
									window.open(getUrl, '_blank');
								}
								else
								{
									var page_filters = scope.page_filters;
									var redirectPage = redirect_config.page;
									var redirectSubmenu = component_config.submenu_key;

									if(typeof(page_filters[redirectPage][redirectSubmenu]) != 'undefined')
									{
										scope.appState['page'] = redirectPage;
										scope.appState['submenu_key'] = redirectSubmenu;
										$.each(page_filters[redirectPage][redirectSubmenu], function(key, value)
										{
											scope.appState[key] = '';
										});

										$.each(redirect_config.fixed_filters, function(key, value)
										{
											scope.appState[key] = value;
										});
										scope.appState[redirect_config.output_filter.name] = redirect_config.output_filter.refer_array[this.category];
										scope.$apply();
										location.reload();
									}
								}

							}
						}
					}
				}
			}
		}

		//update component
		scope[componentKey].data = resultComponentVal.config;

		setTimeout(function () {
			//get the chart object
			var chart = angular.element(document.getElementById(componentKey)).highcharts();
			
			/*var chrt_height = 0;
			var height = chart.chartHeight;
			$.each(chart.series, function(index, series)
			{
				$.each(series.data, function(i, point)
				{
					chrt_height += 40;
				});
			});

			chart.setSize(null,chart.chartHeight);

			console.log(componentKey, chart.chartHeight, chrt_height);*/

			var chart_options = chart.options;
			var yAxis = typeof chart_options.yAxis != 'undefined' ? chart_options.yAxis: {};
			var yAxis = typeof yAxis[0] != 'undefined'? yAxis[0] : yAxis;
			var min_val = typeof yAxis.min != 'undefined'? yAxis.min: null;
			var bar_height = typeof chart_options.bar_height != 'undefined' ? chart_options.bar_height: 40;
			var auto_adjust_height = typeof chart_options.chart.auto_adjust_height != 'undefined' && chart_options.chart.auto_adjust_height === false ? false : true;

			var chrt_height = 0;
			var height = chart.chartHeight;

			var chart_series = chart.series;
		
			$.each(chart_series, function(index, series)
			{
				$.each(series.data, function(i, point)
				{
					chrt_height += bar_height;
				});
			});

			if(chrt_height >= height)
			{
				height = chrt_height;
			}

			if (auto_adjust_height) {
				chart.setSize(null,height);
			}

			var plotHeight = chart.plotHeight;

			for (var j = 0; j < chart.series.length; j++) {
	          for (var i = 0; i < chart.series[j].data.length; i++) {
	          	var d = chart.series[j].data[i];
	          	if(d.y < min_val && typeof d.dataLabel != 'undefined')
				{
		            d.dataLabel.attr({
		              y: plotHeight - d.plotX - 13,
		              x: d.x + 10
		            });
				}
	          }
	        }

		}, 500);

	};

	return instance;
};
